import store from "../../../../store";
import engineer_doc_edit from "./engineer_doc_edit.vue";

window.ENG_DOC_EDIT =  new Vue({
    store,
    name : "ENG_DOC_EDIT",
    el: '#engineer_doc_edit',

    data () {
        return {
            showModal: false,
        }
    },
    created () {

    },

    components : {
        engineer_doc_edit
    }
});
